import { Injectable, signal } from '@angular/core';

/**
 * Tracks app-shell chrome visibility (the mobile header).
 *
 * Guest landing pages hide the header while they are mounted and restore it on
 * destroy, so the "no header on landing pages" rule lives in one place instead
 * of being duplicated across every landing page. The sidebar stays visible.
 */
@Injectable({ providedIn: 'root' })
export class LayoutChromeService {
  private readonly _hideHeader = signal(false);

  /** Whether the app-shell header should be hidden. */
  readonly hideHeader = this._hideHeader.asReadonly();

  setHideHeader(hidden: boolean): void {
    this._hideHeader.set(hidden);
  }
}
